import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { FeaturedSection } from '../components/FeaturedSection';
import { ProductCategories } from '../components/ProductCategories';
import { IndustriesSection } from '../components/IndustriesSection';
import { CapabilitiesSection } from '../components/CapabilitiesSection';
import { TrustSection } from '../components/TrustSection';
import { HeritageSection } from '../components/HeritageSection';
import { PathwaysSection } from '../components/PathwaysSection';
import { ComplianceNewsletterSection } from '../components/ComplianceNewsletterSection';
import { SpecialistsCTASection } from '../components/SpecialistsCTASection';
import { Footer } from '../components/Footer';
import { FloatingReview } from '../components/FloatingReview';
import { MegaMenuShowcase } from '../components/MegaMenuShowcase';
interface HomePageProps {
  onOpenSampleModal?: () => void;
}
export function HomePage({
  onOpenSampleModal
}: HomePageProps) {
  return <div className="min-h-screen bg-white font-sans text-[#0A1628] selection:bg-[#0052CC] selection:text-white overflow-x-hidden" data-id="element-1038">
      <Header onOpenSampleModal={onOpenSampleModal} data-id="element-1039" />
      <main data-id="element-1040">
        <Hero onOpenSampleModal={onOpenSampleModal} data-id="element-1041" />
        <TrustSection data-id="element-1042" />
        <ProductCategories data-id="element-1043" />
        <PathwaysSection onOpenSampleModal={onOpenSampleModal} data-id="element-1044" />
        <IndustriesSection data-id="element-1045" />
        <HeritageSection data-id="element-1046" />
        <FeaturedSection data-id="element-1047" />
        <SpecialistsCTASection onOpenSampleModal={onOpenSampleModal} data-id="element-1048" />
        <ComplianceNewsletterSection data-id="element-1049" />
      </main>
      <Footer data-id="element-1050" />
      <FloatingReview data-id="element-1051" />
    </div>;
}